export const DEPARTMENT = [
  "Geography",
  "Sociology",
  "Hindi",
  "English",
  "Sanskrit",
  "Maithili",
  "Psychology",
  "Economics",
  "Philosophy",
  "History",
  "Political Science",
  "Literature",
  "Law",
  "Public Administration",
  "Education",
  "Art",
  "Physics",
  "Chemistry",
  "Biology",
  "Botany",
  "Zoology",
  "Mathematics",
  "Computer Science",
  "Statistics",
  "Biotechnology",
  "Microbiology",
  "Accountancy",
  "Business Studies",
  "Religion",
  "Anthropology",
  "Archaeology",
  "Library and Information Science",
  "Criminology",
  "International Relations",
  "Gender Studies",
  "Media and Journalism",
  "Engineering",
  "Agricultural Sciences",
  "Finance",
  "Accounting",
  "Film Studies",
  "World Literature",
  "Linguistics",
  "Management",
  "Politics and International Studies",
  "Arabic",
  "Assamese",
  "Bengali",
  "German",
  "Gujarati",
  "Japanese",
  "Kannada",
  "Kashmiri",
  "Malayalam",
  "Manipuri",
  "Marathi",
  "Mizo",
  "Nepali",
  "Odia",
  "Persian",
  "Punjabi",
  "Russian",
  "Sindhi",
  "Spanish",
  "Tamil",
  "Telugu",
  "Tibetan",
  "Urdu",
  "Astronomy",
  "Environmental Sciences",
  "Dentistry",
  "Genetics",
  "Immunology",
  "Medical",
  "Medicine",
  "Nursing",
  "Toxicology",
  "Veterinary",
];
